import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';
import {
  isActive, IsTablet, isFreeUser, MaxWidthAppV2, IsMobile, valueToObject, MinWidthApp, isEnterpriseUser
} from '../../Utils/UtilityFunctions';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import AccountPopOver from '../../Components/common/components/AccountPopOver';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import GlobalButton from '../../Components/common/components/GlobalButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import { maxWidth, retina, retinaOne, maxMobile, secondaryFont, primaryHeadingColor, wMedium, SecondaryColor, primaryColor, greyColor, primaryFont, minWidthApp, minTablet, maxTablet, smMobile, xmMobile, midTablet, boxShadow, midWidthApp, maxWidth1300 } from '../../Utils/utilsStyle';
import EditIcon from '../../Components/company/svgIcons/EditIcon';
import ExportIcon from '../../Components/common/assets/svgIcons/ExportIcon';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCompaniesExportUrl, selectisComparisonLoading, } from '../../Selector/CompaniesSelector';
import { Company } from '../../Types/CompaniesTypes';
import { Checkbox, Col, Row } from 'antd';
import CompanyCardLarge from '../../Components/common/components/CompanyCardLarge';
import BinIcon from '../../Components/company/svgIcons/BinIcon';
// import CompaniesSection from 'Components/company/components/CompaniesSection';
import { actions as clusterActions } from '../../Slice/ClustersSlice';
import { selectAllClusterCompanies, selectAllClusterCompanyCount, selectClusterDrawerOpen, selectClusterName, selectClusterShared, selectClusterSortingType, selectClustersShared, selectCreationSuccess, selectDetailsLoading, selectSelectedClusterCompanies, selectSharedByFirstName } from '../../Selector/ClustersSelector';
import DrawerAccountCluster from '../../Components/company/components/DrawerAccountCluster';
import { selectShowGlobalGilroy } from '../../Selector/GlobalSearchContentSelector';
import { useGilroy } from '../../Utils/hooks/useGilroy';
import { Gilroy } from '../../Components/gilroy/LazyGilroy';
import DrawerPeopleGroup from '../../Components/people/components/DrawerPeopleGroup';
import ShareGroupPeopleModal from '../../Components/common/modal/ShareGroupPeopleModal';
import SharedBadge from '../../Components/common/components/SharedBadge';
import CompaniesSvg from '../../Components/layout/assets/CompaniesSvg';
import ClusterInsightSection from './ClusterInsightSection';
import { SelectedCompany } from '../../Types/ClustersTypes';
import { flushSync } from 'react-dom';
import CustomSlider from '../../Components/common/components/CustomSlider';
import { ACCOUNT_CLUSTER_COMPANY_DETAILS_LIMIT, FILE_DOWNLOAD_SUCCESS, FILE_DOWNLOAD_FAIL } from '../../Utils/Constants';
import SliderCircledBackIcon from '../../Components/common/assets/svgIcons/SliderCircledBackIcon';
import SliderCircledForwardIcon from '../../Components/common/assets/svgIcons/SliderCircledForwardIcon';
import { actions as helperActions } from '../../Slice/HelperSlice';
import ClusterDetailPageSkeleton from '../../Components/common/skeleton/ClusterDetailPageSkeleton';
import classNames from 'classnames';
import Cross from '../../Components/globalSearch/assets/Cross';
import Title from '../../Components/common/components/Title';
import Edit from '../../Components/common/assets/svgIcons/Edit';
import Tick from '../../Components/common/assets/svgIcons/Tick';
import FilterCompanySortBy from '../../Components/common/components/FilterCompanySortBy';
import DrawerPersonas from 'Components/people/components/DrawerPersonas';
import { actions as flurryActions } from 'Slice/HelperSlice';

const Wrapper = styled.div`
  /* padding-bottom: 150px; */
.fancy-box {
  border-radius: 22px;
  background: rgb(255, 255, 255);
  padding: 40px 50px 40px 50px;
  margin-top: 50px;
  box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 17px 20px 25px 20px;
  }
  @media all and (max-width: ${maxWidth}) , ${retinaOne} {
    padding: 17px 20px 25px 20px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 17px 16px 16px 16px;
  }
  .header-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 22px;
    .left-section {
      display: flex;
      align-items: center;
      column-gap: 6px;
      @media all and (max-width: ${maxMobile}) {
        column-gap: 4px;
        height: 37px;
      }
      .cluster-name, .count {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 24px;
        font-weight: ${wMedium};
        line-height: 27px;
        letter-spacing: -0.4px;
        margin-bottom: 0;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 19px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 15px;
        }
        @media all and (max-width: ${smMobile}) {
          font-size: 15px;
        }
      }
      .cluster-name {
        max-width: 350px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          max-width: 300px;
        }
        @media all and (max-width: ${maxWidth1300}) {
          max-width: 250px;
        }
        @media all and (max-width: ${midWidthApp}) {
          max-width: 150px;
        }
        @media all and (max-width: ${minWidthApp}) {
          max-width: 130px;
        }
        @media all and (max-width: ${maxTablet}) {
          max-width: 150px;
        }
        @media all and (max-width: ${maxMobile}) {
          max-width: 250px;
        }
      }
      .edit-icon {
        cursor: pointer;
        svg {
          width: 22px;
          height: 22px;
          @media all and (max-width: ${minWidthApp}) {
            width: 16px;
            height: 16px;
          }
        }
      }
      .editable-inner{
        position: relative;
        width: 380px;
        height: 41px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 37px;
          width: 350px;
        }
        @media all and (max-width: ${maxWidth1300}) {
          width: 260px
        }
        @media all and (max-width: ${midWidthApp}) {
          width: 210px;
        }
        @media all and (max-width: ${minWidthApp}) {
          width: 180px;
        }
        @media all and (max-width: ${maxTablet}) {
          width: 250px;
        }
        @media all and (max-width: ${minTablet}) {
          width: 200px
        }
        @media all and (max-width: ${maxMobile}) {
          width: 275px;
        }
        input{
          position: absolute;
          background-color:#fff;
          border-radius:8px;
          border:none;
          width: 100%;
          height: 41px;
          top:0;
          left: 0;
          outline:none;
          padding:0 70px 0 15px;
          font-size:16px;
          box-shadow:${boxShadow};
          color: #424B50;
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 18px;
          @media all and (max-width: ${maxWidth}) , ${retina} {
            height: 37px;
            /* top: 2px; */
          }
          &::focus, &:active{
            outline:none;
            border:none;
          }
        }
        .tick{
          cursor: pointer;
          position: absolute;
          right: 20px;
          top:0;
          height: 45px;
          svg{
            max-width: 17px;
            height: 45px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              height: 40px;
            }
          }
        }
        .cross{
          cursor: pointer;
          position: absolute;
          right: 50px;
          top:0;
          svg{
            height: 45px;
            width: 17px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              height: 40px;
            }
            path {
              fill: red;
            }
          }
        }
      }
    }
    .right-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 8px;
      @media all and (max-width: ${maxWidth1300}) {
        column-gap: 6px;
      }
      @media all and (max-width: ${smMobile}) {
        column-gap: 4px;
      }
      .selected-count {
        color: ${primaryColor};
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: normal;
        @media all and (max-width: ${maxWidth1300}) {
          font-size: 12px;
        }
        @media all and (max-width: ${smMobile}) {
          font-size: 10px;
        }
      }
      .remove-cancel-btn-div {
        display: flex;
        align-items: center;
        column-gap: 8px;
        @media all and (max-width: ${smMobile}) {
          column-gap: 4px;
        }
        .remove-btn {
          @media all and (max-width: ${maxWidth}), ${retina} {
            padding: 7px 12px 6px;
          }
          @media all and (max-width: ${maxMobile}) {
            padding: 6px 12px 7px;
          }
          @media all and (max-width: ${smMobile}) {
            font-size: 10px;
            padding: 4px 6px
          }
        }
        .cancel-btn {
          @media all and (max-width: ${smMobile}) {
            padding: 6px 6px 8px;
            font-size: 10px;
          }
        }
      }
      .edit-btn {
        column-gap: 6px;
        svg {
          width: 18px;
          height: 18px;
          path {
            fill: ${SecondaryColor}
          }
        }
        @media all and (max-width: ${maxWidth}), ${retina} {
          padding: 8px 10px 9px;
        }
        @media all and (max-width: ${maxTablet}) {
          column-gap: 0px;
          padding: 8px;
        }
        @media all and (max-width: ${smMobile}) {
          padding: 6px;
        }
      }
      .share-btn-wrapper {
        &.disabled {
          opacity: 0.5;
          pointer-events: none;
        }
        display: flex;
        align-items: center;
        .share-button-group.groupPageButton {
          background-color: #fff;
          border: 1.6px solid ${SecondaryColor};
          height: auto;
          padding: 10px 16px;
          border-radius: 8px;
          color: ${SecondaryColor};
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          line-height: normal;
          display: inline-flex;
          align-items: center;
          cursor: pointer;
          @media all and (max-width: ${maxWidth}), ${retina} {
            padding: 8px 16px 9px;
          }
          @media all and (max-width: ${maxTablet}) {
            padding: 8px 9px 9px;
          }
          @media all and (max-width: ${smMobile}) {
            padding: 6px;
          }
          .icon-mode {
            display: inline-flex;
            align-items: center;
            column-gap: 6px;
            .icon-mode-text {
              color: ${SecondaryColor};
              font-weight: ${wMedium};
              font-family: ${primaryFont};
              font-size: 16px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 12px;
              }
              @media all and (max-width: ${maxTablet}) {
                display: none;
              }
            }
            .seperator {
              border-left: 1.6px solid ${SecondaryColor};
              height: 18px;
              margin: 0 0 0 2px;
            }
            .share-icon {
              display: inline-flex;
              align-items: center;
              svg {
                height: 18px;
                width: 18px;
                g {
                  fill: ${SecondaryColor};
                }
              }
            }
          }
        }
      }
      .add-account-btn {
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
          padding: 10px;
        }
        @media all and (max-width: ${smMobile}) {
          font-size: 10px;
          padding: 7px 6px 8px;
        }
      }
      .apply-btn {
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
          padding: 10px 6px;
        }
        @media all and (max-width: ${smMobile}) {
          font-size: 10px;
          padding: 8px 6px 8px;
        }
      }
      .sort-by-btn {
        &.iconModeState {
          &.activeBtnState {
            background-color: transparent;
          }
          border: 1px solid #CBCBCA;
          box-shadow: none;
          @media all and (max-width: ${smMobile}) {
            padding: 4px;
            height: 32px;
            width: 32px;
            min-width: 32px;
          }     
        }
      }
      .export_btn {
        &:hover {
          border: 1px solid ${primaryColor};
          color: ${primaryColor}; 
            svg {
              path {
                fill: ${primaryColor}; 
              }
            }
        }
        svg {
          margin-right: 10px;
          width: 17px;
          min-width: 17px;
          @media all and (max-width: ${maxWidth}) ,${retina} {
            width: 14px;
            min-width: 14px;
          }
        }
        @media all and (max-width: ${maxTablet}){ 
          width: 38px;
          height: 38px;
          padding: 13px;
          svg {
            width: 14px;
            min-width: 14px;
          }
        }
        @media all and (max-width: ${smMobile}) {
          padding: 10px;
          height: 32px;
          width: 32px;
        } 
      }
    }
    @media all and (max-width: ${maxMobile}) {
      flex-direction: column;
      justify-content: unset;
      align-items: unset;
      row-gap: 10px;
      .right-section {
        justify-content: end;
      }
    }
  }
  .companies-section {
    .custom-slider-wrapper {
      .slider-content {
        margin: 0px !important;
        .slick-slider {
          .slick-slide {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    .ant-col {
      display: flex;
      align-items: center;
      justify-content: center;
    }
      .company-card-wrapper {
        position: relative;
        /* width: 215px !important; */
        .floating-checkbox {
          &.ant-checkbox-wrapper {
            width: auto !important;
          }
          position: absolute;
          right: -10px;
          top: 0px;
          z-index: 1;
          @media all and (max-width: ${maxWidth}), ${retina} {
            right: -6px;
          }
          @media all and (max-width: ${minWidthApp}) {
            right: -2px;
          }
          @media all and (max-width: ${minTablet}) {
            right: 8px;
          }
        }
        .company-item {
          @media all and (max-width: ${xmMobile}) {
            max-width: 145px !important;
            width: 145px !important;
          }
          .deleteButton {
            @media all and (max-width: ${minWidthApp}) {
              right: -4px;
            }
            @media all and (max-width: ${minTablet}) {
              right: 7px;
            }
          }
          .company-image-parent {
            @media all and (max-width: ${minWidthApp}) {
              width: 150px;
            }
            @media all and (max-width: ${minTablet}) {
              width: 130px;
            }
            @media all and (max-width: ${xmMobile}) {
              width: 115px;
            }
          }
          .company-stats{
            p {
              margin-left: 5px;
              &:nth-child(1){
                margin-left: 0px;
                padding-right: 5px;
              }
            }
            .seperator {
              margin-top: -8px;
              font-size: 10px;
            }
            .company-ticker-stats {
              max-width: 37%;
            }
            span {
              @media all and (max-width: ${minWidthApp}){
                margin-left: 5px;
              }
            }
          }
          .follow-action {
            display: none;
          }
        }
      }
    /* } */
  }
  .empty {
      height: 223px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      row-gap: 8px;
      .heading {
        color: #0D0D0D;
        text-align: center;
        font-family: "Roboto Slab";
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: -0.4px;
      }
      .sub-heading {
        color: #667982;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.4px;
      }
    }
}
.not-applied-section {
  &.loader {
    height: calc(100vh - 555px);
  }
  height: calc(100vh - 475px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 16px;
  .icon {
    svg {
      height: 50px;
      width: 50px;
      g {
        fill: #CBCBCA;
      }
      path {
        fill: #CBCBCA;
      }
    }
    
  }
  .text {
    color: #424B50;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: -0.4px;
    max-width: 230px;
  }
  .gilroy-loader {
    width: 156px;
    height: 156px;
  }
}
;`
const ClusterDetailPage = function ClusterDetailPage() {
  const getSlidesToShow = () => {
    if (window.innerWidth <= 575) return 2;
    if (window.innerWidth <= 768) return 3;
    if (window.innerWidth <= 1024) return 4;
    if (window.innerWidth <= 1440) return 5;
    return 6;
  }
  const isTab = IsTablet();
  const isMaxWidthTabV2 = MaxWidthAppV2();
  const isMobile = IsMobile()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());
  const [currentPage, setCurrentPage] = useState(1);
  const { gilroyStates, gilroyActions } = useGilroy();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [applyCompanies, setApplyCompanies] = useState<boolean>(false);
  const [companiesToRemove, setCompaniesToRemove] = useState<number[]>([]);
  const [selectedStrategicHighlight, setSelectedStrategicHighlight] = useState<string | undefined>(undefined);
  const [appliedCompanies, setAppliedCompanies] = useState<SelectedCompany[]>([]);
  const [textEditable, setTextEditable] = useState<boolean>(false);
  const [editTitle, setEditTitle] = useState<string>('');
  const [searchParams] = useSearchParams();
  const clusterId = searchParams.get('clusterId');
  const clusterIdParsed = clusterId ? parseInt(clusterId, 10) : 0;
  const detailsLoading = useSelector(selectDetailsLoading);
  // const clusterId = useSelector(selectClusterId);
  const clusterName = useSelector(selectClusterName);
  const clusterShared = useSelector(selectClusterShared);
  const clustersShared = useSelector(selectClustersShared);
  const sortingType = useSelector(selectClusterSortingType);
  const selectedCompanies = useSelector(selectSelectedClusterCompanies);
  const clusterCompanies: Company[] = useSelector(selectAllClusterCompanies);
  const clusterCompanyCount = useSelector(selectAllClusterCompanyCount);
  const sharedByFirstName = useSelector(selectSharedByFirstName);
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const creationStatus = useSelector(selectCreationSuccess);
  const selectedCompaniesRef = useRef<SelectedCompany[]>([]);
  const exportLoading: boolean = useSelector(selectisComparisonLoading);
  const companiesExportUrl: string = useSelector(selectCompaniesExportUrl);
  const isEnterprise = isEnterpriseUser();

  const maxSelectedCount =
    (clusterCompanyCount || clusterCompanies.length) > ACCOUNT_CLUSTER_COMPANY_DETAILS_LIMIT
      ? ACCOUNT_CLUSTER_COMPANY_DETAILS_LIMIT
      : (clusterCompanyCount || clusterCompanies.length);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlidesToShow());
    };

    window.addEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setEditTitle(clusterName);
  }, [clusterName, textEditable]);

  useEffect(() => {
    if (!clusterIdParsed) return;
    if (isFreeUser()) {
      navigate('/feed');
    }
    dispatch(helperActions.callFlurryEvent(
      valueToObject('Cluster_Opened', 0, { cluster_id: clusterIdParsed }),
    ));
    dispatch(clusterActions.getClusterDetails({
      clusterId: clusterIdParsed,
    }));

    setApplyCompanies(false);
    dispatch(clusterActions.resetClusterSelectedCompanies());
    setEditClicked(false);
    setCompaniesToRemove([]);
    setAppliedCompanies([]);

    // sorting is scoped to a single cluster visit, clear it when leaving/switching
    return () => {
      dispatch(clusterActions.setClusterSortingType(''));
    };
  }, [clusterIdParsed, dispatch]);

  const prevSortingTypeRef = useRef(sortingType);
  useEffect(() => {
    if (!clusterIdParsed) return;
    const prevSortingType = prevSortingTypeRef.current;
    prevSortingTypeRef.current = sortingType;
    if (!sortingType && !prevSortingType) return;
    dispatch(clusterActions.getClusterDetails({
      clusterId: clusterIdParsed,
      sortingType: sortingType || 'dateFollowed:desc',
    }));
    dispatch(clusterActions.resetClusterSelectedCompanies());
    setApplyCompanies(false);
    setAppliedCompanies([]);
  }, [clusterIdParsed, sortingType, dispatch]);

  useEffect(() => {
    if (creationStatus === true) {
      dispatch(helperActions.setNotification({
        message: 'Account cluster created successfully',
        proTip: false,
        rightPlacement: false,
        classnameFlag: true,
        groupId: 0,
      }))
    }
    dispatch(clusterActions.resetClusterCreationStatus(false));
  }, [dispatch]);

  useEffect(() => {
    const validCompanyIds = clusterCompanies.map((company) => company.companyId);
    dispatch(clusterActions.pruneClusterSelectedCompanies(validCompanyIds));
  }, [clusterCompanies, dispatch]);

  const hasSelectionChanged = () => {
    if (selectedCompanies.length !== appliedCompanies.length) {
      return true;
    }

    const selectedIds = selectedCompanies
      .map(c => c.companyId)
      .sort((a, b) => a - b);

    const appliedIds = appliedCompanies
      .map(c => c.companyId)
      .sort((a, b) => a - b);

    return JSON.stringify(selectedIds) !== JSON.stringify(appliedIds);
  };

  const syncSelectionAfterRemoval = (removedIds: number[]) => {
    dispatch(clusterActions.removeClusterSelectedCompanies(removedIds));
  };

  const editHandler = () => {
    setEditClicked(true);
  }
  const cancelHandler = () => {
    setEditClicked(false);
    setCompaniesToRemove([]);
  }

  const shareClusterHandler = (check: boolean) => {
    if (check) {
      dispatch(clusterActions.setSelectedClusters([{
        clusterName: clusterName || '',
        clusterId: clusterIdParsed,
      }]));
    }
  };

  useEffect(() => {
    if (clustersShared) {
      dispatch(clusterActions.setSelectedClusters([]));
    }
  }, [clustersShared, dispatch]);

  const handleCompanySelect = (
    companyId: number,
    companyName: string
  ) => {
    const exists = selectedCompanies.some(
      (company) => company.companyId === companyId
    );

    if (!exists && selectedCompanies.length >= ACCOUNT_CLUSTER_COMPANY_DETAILS_LIMIT) {
      dispatch(helperActions.setNotification({
        message: `You can only select up to ${ACCOUNT_CLUSTER_COMPANY_DETAILS_LIMIT} companies.`,
        proTip: false,
        rightPlacement: false,
        classnameFlag: false,
        groupId: 0,
      }))
      return;
    }

    dispatch(clusterActions.toggleClusterSelectedCompany({ companyId, companyName }));
  };

  const handleCompanyRemoveSelect = (companyId: number) => {
    setCompaniesToRemove((prev) => {
      if (prev.includes(companyId)) {
        return prev.filter((id) => id !== companyId);
      }

      return [...prev, companyId];
    });
  };

  const removeHandler = () => {
    if (!companiesToRemove.length) {
      return;
    }
    const removedIds = [...companiesToRemove];
    syncSelectionAfterRemoval(removedIds);
    dispatch(clusterActions.manageAccountCluster({
      type: 'edit',
      clusterId: clusterIdParsed,
      removedCompanyIds: removedIds.join(','),
      ...(sortingType ? { sortingType } : {}),
    }));
    dispatch(helperActions.callFlurryEvent(
      valueToObject('Cluster_Companies_remove', 0),
    ));
    setCompaniesToRemove([]);
    setEditClicked(false);
    dispatch(helperActions.setNotification({
      message: "Account(s) removed successfully",
      proTip: false,
      rightPlacement: false,
      classnameFlag: true,
      groupId: 0,
    }))
  };

  const applyHandler = () => {
    if (!selectedCompanies.length) {
      return;
    }
    dispatch(helperActions.callFlurryEvent(
      valueToObject('apply_cluster', 0),
    ));
    setApplyCompanies(true);
    setAppliedCompanies(selectedCompanies);
    dispatch(clusterActions?.setAllCompanyDetailsLoading(true));
  }

  const addAccountHandler = () => {
    dispatch(clusterActions.setDrawerOpen(true));
  }

  const toggleDrawer = () => {
    dispatch(clusterActions.setDrawerOpen(!clusterDrawerOpen))
  }

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  const handleHighlightClick = (prompt: string) => {
    flushSync(() => setSelectedStrategicHighlight(undefined));
    setSelectedStrategicHighlight(prompt);
  };

  const handleGilroyClose = () => {
    setSelectedStrategicHighlight(undefined);
  };

  const handleTitleEdit = (newTitle?: string) => {
    if (newTitle === clusterName) {
      dispatch(helperActions.setNotification({
        message: 'Name duplication is not allowed',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }))
      return;
    }
    const editClusterName = newTitle?.trim().replace(/  +/g, ' ');
    if (editClusterName !== '') {
      dispatch(clusterActions.manageAccountCluster({
        type: 'edit',
        clusterId: clusterIdParsed,
        clusterName: editClusterName,
        ...(sortingType ? { sortingType } : {}),
      }));
      setTextEditable(false);
    } else {
      dispatch(helperActions.setNotification({
        message: 'Cluster name cannot be empty',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }))
    }
  }

  const handleExport = () => {
    setEditClicked(false);
    setCompaniesToRemove([]);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('click_exportButton_companyClusterDashboard', 0),
    ));
    // if (selectedCompanies.length > 0) {
    //   dispatch(companiesActions.compareCompaniesExport({
    //     screenName: 'clusterScreen',
    //     clusterId: clusterIdParsed,
    //     companyIds: selectedCompanies.map((company) => company.companyId).join(','),
    //   }));
    // }
    dispatch(companiesActions.compareCompaniesExport({
      screenName: 'clusterScreen',
      clusterId: clusterIdParsed,
      sortingType: sortingType || 'dateFollowed:desc',
    }));
  };

  useEffect(() => {
    if (companiesExportUrl !== '') {
      const newWin = window.open(companiesExportUrl, '_blank');
      if (newWin) {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_SUCCESS,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: true,
        }));
      } else {
        dispatch(helperActions.setNotification({
          message: FILE_DOWNLOAD_FAIL,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
      }
      dispatch(companiesActions.setExportCompanies(''));
    }
  }, [companiesExportUrl]);
  return (
    <Wrapper>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => {
            navigate(-1)
          }} />
          <h1 className='heading text-truncate-two-line'>Accounts Clusters</h1>
        </div>
        <div className="right-side-wrap">
          {isActive() ? (
            <>
              <GlobalSearch iconMode={isTab} />
              <DrawerAlerts />
              <AccountPopOver />
            </>
          ) : (
            <GlobalButton
              title="Login"
              textColor="#ffffff"
              bgColor="#1EC252"
              borderRadius="25px"
              innerSpace="8px 20px"
              PaddingSm="4px 16px 6px 16px"
              height="36px"
              fontSize="18px"
              fontSizeSm="16px"
              buttonClassName="button-follow"
              onButtonClick={() => navigate('/')}
            />
          )}
        </div>

      </NavBarPrimary>
      {
        !detailsLoading ? (
          <div className='container'>
            <div className='fancy-box'>
              <div className="header-section">
                <div className='left-section'>
                  {
                    !textEditable ? (
                      <>
                        <div className='cluster-name text-truncate'>
                          {clusterName}
                        </div>
                        <div className='count'>
                          {`(${clusterCompanyCount})`}
                        </div>
                        {
                          clusterShared === 0 && (
                            <div
                              className='edit-icon'
                              role='button'
                              onClick={() => { setTextEditable(true) }}
                              aria-label='open'
                              tabIndex={0}
                            >
                              <Edit />
                            </div>
                          )
                        }

                      </>
                    ) : (
                      <div className='editable-inner'>
                        <input
                          type='text'
                          name='title'
                          defaultValue={clusterName}
                          value={editTitle}
                          onChange={(e) => { setEditTitle(e.target.value) }}
                          maxLength={40}
                        />
                        <span
                          className='cross'
                          role='button'
                          aria-label='close'
                          tabIndex={0}
                          onClick={() => setTextEditable(false)}
                        >
                          <Cross />
                        </span>
                        <span
                          className='tick'
                          role='button'
                          aria-label='close'
                          tabIndex={0}
                          onClick={() => { handleTitleEdit(editTitle) }}
                        >
                          <Tick />
                        </span>
                      </div>
                    )
                  }
                </div>
                <div className='right-section'>
                  {
                    selectedCompanies.length > 0 && (
                      <div className='selected-count'>
                        selected ({selectedCompanies.length}/{maxSelectedCount})
                      </div>
                    )
                  }
                  {
                    editClicked ? (
                      <div className='remove-cancel-btn-div'>
                        <GlobalButton
                          title={isTab ? '' : 'Remove'}
                          textColor={greyColor}
                          bgColor='#fff'
                          outlineColor={greyColor}
                          innerSpace='8px 12px'
                          IconLeft={<BinIcon />}
                          onButtonClick={removeHandler}
                          disabled={companiesToRemove.length === 0}
                          buttonClassName='remove-btn'
                        />
                        <GlobalButton
                          title={isTab ? '' : 'Cancel'}
                          textColor={greyColor}
                          bgColor='#fff'
                          outlineColor={greyColor}
                          innerSpace='10px 12px'
                          IconLeft={isTab ? <Cross /> : undefined}
                          onButtonClick={cancelHandler}
                          buttonClassName='cancel-btn'
                        />
                      </div>
                    ) : (
                      <GlobalButton
                        title={isTab ? '' : 'Edit'}
                        textColor={SecondaryColor}
                        bgColor='#fff'
                        outlineColor={SecondaryColor}
                        innerSpace='10px 10px'
                        IconLeft={<EditIcon />}
                        buttonClassName='edit-btn'
                        onButtonClick={editHandler}
                        disabled={clusterCompanyCount === 0 || detailsLoading}

                      // disabled={detailsLoading}
                      />
                    )
                  }

                  {!isFreeUser() && (
                    <div className={classNames("share-btn-wrapper", { disabled: clusterCompanyCount === 0 })}>
                      <ShareGroupPeopleModal
                        onClickHandler={() => shareClusterHandler(true)}
                        onCancelHandler={() => shareClusterHandler(false)}
                        iconMode
                        isDetailPage
                        inClusterMode
                      />
                    </div>
                  )}
                  <GlobalButton
                    title='Add Account'
                    textColor='#fff'
                    bgColor={SecondaryColor}
                    outlineColor={SecondaryColor}
                    innerSpace='10px 16px'
                    buttonClassName='add-account-btn'
                    onButtonClick={addAccountHandler}
                    disabled={detailsLoading}
                  />
                  <GlobalButton
                    title='Apply'
                    textColor='#fff'
                    bgColor={primaryColor}
                    outlineColor={primaryColor}
                    innerSpace='10px 10px'
                    buttonClassName='apply-btn'
                    onButtonClick={applyHandler}
                    disabled={selectedCompanies.length === 0 || editClicked || !hasSelectionChanged() || clusterCompanyCount === 0}
                  />
                  <FilterCompanySortBy
                    buttonHeight="38px"
                    buttonHeightSm="38px"
                    iconModeBtnWidth="38px"
                    iconModeFlag={isTab}
                    inCluster
                    setEditClicked={() => setEditClicked(false)}
                    setRemovedCompanies={() => setCompaniesToRemove([])}
                    disabled={clusterCompanyCount === 0 || detailsLoading}
                  />
                  <GlobalButton
                    title={isTab ? '' : 'Export'}
                    textColor="#7E7E7E"
                    bgColor="#fff"
                    outlineColor="#DADADA"
                    innerSpace="9px 15px 9px 15px"
                    PaddingXsm="6px 15px"
                    IconLeft={<ExportIcon />}
                    buttonClassName="share-button mr-24 export_btn"
                    rightSeparatorClassName="right-separator-class"
                    onButtonClick={handleExport}
                    disabled={editClicked || exportLoading || clusterCompanyCount === 0 || detailsLoading}
                  />
                </div >
              </div >
              <div className='companies-section'>
                <CustomSlider
                  slidesToShow={slidesToShow}
                  totalItems={clusterCompanies.length}
                  NextArrow={SliderCircledForwardIcon}
                  PrevArrow={SliderCircledBackIcon}
                  isCluster={true}
                >
                  {clusterCompanies.map((company) => {
                    const isSelected = selectedCompanies.some(
                      (selected) => selected.companyId === company.companyId
                    );

                    return (
                      <div
                        key={company.companyId}
                        className="company-card-wrapper"
                        onClick={() => {
                          if (!editClicked) {
                            handleCompanySelect(company.companyId, company.companyName,);
                          }
                        }}
                        role='button'
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if ((e.key === 'Enter' || e.key === ' ') && !editClicked) {
                            e.preventDefault();
                            handleCompanySelect(company.companyId, company.companyName,);
                          }
                        }}
                      >
                        {!editClicked && (
                          <Checkbox
                            className="floating-checkbox"
                            checked={isSelected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleCompanySelect(
                                company.companyId,
                                company.companyName
                              )
                            }
                            }
                          />
                        )}

                        <CompanyCardLarge
                          companyData={company}
                          removeButton={editClicked}
                          removed={companiesToRemove.includes(
                            company.companyId
                          )}
                          handleCompanyRemoved={() =>
                            handleCompanyRemoveSelect(company.companyId)
                          }
                          disableNavigation={true}
                        />
                      </div>
                    );
                  })}
                </CustomSlider>
              </div>
              {
                clusterCompanyCount === 0 && (
                  <div className='empty'>
                    <div className="heading">No Accounts Found</div>
                    <div className="sub-heading">
                      Add accounts to begin tracking insights and relationships.
                    </div>
                  </div>
                )
              }
            </div>
            {
              !applyCompanies ? (
                <div className='not-applied-section'>
                  <div className="icon">
                    <CompaniesSvg color='#0000' />
                  </div>
                  <div className='text'>
                    Select the companies you want to explore, then click Apply to view their insights and engagement details.
                  </div>
                </div>
              ) : (
                <ClusterInsightSection
                  clusterId={clusterIdParsed}
                  appliedCompanies={appliedCompanies}
                  handleHighlightClick={handleHighlightClick}
                  onGilroyClose={handleGilroyClose}
                />
              )
            }
          </div>
        ) : (
          <ClusterDetailPageSkeleton />
        )
      }
      <DrawerAccountCluster
        toggleDrawer={toggleDrawer}
        mode="create"
        isAddDrawer={true}
      />
      <DrawerPeopleGroup
        openNewCreate={openCreateModal}
        setOpenNew={toggle}
        showNew={showNew}
        toggleShowNew={(bool: boolean) => setShowNew(bool)}
        disableDrop
        noButton
      />
      {isEnterprise && <DrawerPersonas />}
      {
        showGlobalGilroy ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} seedPrompt={selectedStrategicHighlight} />
        ) : (
          null
        )
      }
    </Wrapper >
  );
};

export default ClusterDetailPage;